import React, { FC } from "react";
// libs
import NextImage from "next/image";
import { DateTime } from "luxon";
// utils
import { getTheStars } from "src/utils/reviews";
import {
  Title,
  ReviewCardWrapper,
  StarsAndLabel,
  Stars,
  Label,
  ReviewerDetails,
  Review,
} from "./ReviewCard.styles";
// types
import { IReview } from "src/types";

interface IReviewCardProps {
  verified?: boolean;
}

const ReviewCard: FC<IReview & IReviewCardProps> = ({
  rating,
  verified,
  is_name_hidden,
  reviewer_name,
  description,
  title,
  updated_at,
}) => {
  const formattedDate = DateTime.fromISO(updated_at).toFormat("dd/LL/yyyy");

  return (
    <ReviewCardWrapper>
      <Title>{title}</Title>
      <StarsAndLabel>
        <Stars>
          {getTheStars(rating).map((starSrc, idx) => (
            <NextImage key={idx} src={starSrc} width={17} height={16} />
          ))}
        </Stars>
        {verified ? <Label>Verified</Label> : null}
      </StarsAndLabel>

      <ReviewerDetails>
        {is_name_hidden ? "Anonymous," : reviewer_name ? `${reviewer_name},` : "Anonymous,"}{" "}
        {formattedDate}
      </ReviewerDetails>
      <Review>{description}</Review>
    </ReviewCardWrapper>
  );
};

export default ReviewCard;
